import React from 'react';
import { withFormik } from 'formik';
import * as Yup from 'yup';
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  FormFeedback,
} from 'reactstrap';
import { Link, useParams } from 'react-router-dom';

function RubricForm({
  submitLabel = 'Update',
  cancelLabel = 'Cancel',
  cancelUrl,
  autoFocus,
  values,
  touched,
  errors,
  handleChange,
  handleBlur,
  handleSubmit,
  isSubmitting,
}) {
  const { workspaceId } = useParams();

  const formikAttributes = (fieldName) => ({
    id: fieldName,
    name: fieldName,
    value: values[fieldName],
    onChange: handleChange,
    onBlur: handleBlur,
    invalid: errors[fieldName] && touched[fieldName],
  });

  const formikFeedback = (fieldName) => {
    return errors[fieldName] && touched[fieldName] ? (
      <FormFeedback>{errors[fieldName]}</FormFeedback>
    ) : null;
  };

  return (
    <Form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-12 col-md-6 col-lg-4">
          <FormGroup>
            <Label for="name">Name</Label>
            <Input
              type="text"
              {...formikAttributes('name')}
              autoFocus={autoFocus}
              disabled={isSubmitting}
            />
            {formikFeedback('name')}
          </FormGroup>
        </div>
      </div>
      <div>
        <Button color="primary" type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Saving…' : submitLabel}
        </Button>
        <Link
          to={cancelUrl ?? `/w/${workspaceId}/rubrics`}
          className="btn btn-secondary"
        >
          {cancelLabel}
        </Link>
      </div>
    </Form>
  );
}

const FormikRubricForm = withFormik({
  enableReinitialize: true,
  mapPropsToValues: ({ rubric }) => {
    return {
      name: rubric?.name || '',
    };
  },
  validationSchema: Yup.object().shape({
    name: Yup.string().required('What should we call this rubric?'),
  }),
  handleSubmit: async (values, bag) => {
    const { setSubmitting, props } = bag;
    const { onSubmit = () => {} } = props;
    setSubmitting(true);
    try {
      await onSubmit(values);
    } finally {
      setSubmitting(false);
    }
  },
  displayName: 'RubricForm',
})(RubricForm);

export default FormikRubricForm;
